import './Value.css';
export var valueStyle = '_eb7xye0-2-0-1';